import React from "react";
import ApproveIcon from "../../Assets/approve-icon.png";
import CancelIcon from "../../Assets/cancel-icon.png";
import { kepalaShiftTimOne, kepalaShiftTimTwo } from "../../util/constant";
import "./LemburKaryawan.css";
import { useLemburKaryawan } from "./useLemburKaryawan";
import Select from "react-select";
import { clockJam } from "../../util/constant";
import RefreshIcon from "../../Assets/refresh-icon.png";
import WaitingIcon from "../../Assets/waiting_icon.png";
import ApprovedIcon from "../../Assets/approved_icon.png";
import { hasRole } from "../../util/utilFunction";
import moment from "moment";

const LemburKaryawan = () => {
  const {
    dataUser,
    listLembur,
    filterCatatan,
    dateFilter,
    setDateFilter,
    filterKepala,
    setFilterKepala,
    reFormat,
    operatorPick,
    setOperatorPick,
    rencanaMasuk,
    setRencanaMasuk,
    rencanaKeluar,
    setRencanaKeluar,
    pekerjaan,
    setPekerjaan,
    catatan,
    setCatatan,
    handleKirimLembur,
    setIsReload,
    filterKepalaList,
    setFilterKepalaList,
    filterApproval,
  } = useLemburKaryawan();

  const canInputLembur = hasRole(
    dataUser,
    "super_user",
    "produksi_leader",
    "ppic_admin",
    "mesin_admin",
    "warehouse_admin",
    "mold_admin",
    "qc_admin",
    "pr_admin",
    "sp_admin"
  );
  const canFilterKepala = hasRole(dataUser, "super_user", "ppic_admin");

  const kepalaOptions =
    dataUser.tim === 1 ? kepalaShiftTimOne : kepalaShiftTimTwo;

  return (
    <div className="lbr-page">
      <h1 className="lbr-title">Form Lembur</h1>

      {/* ================= FORM INPUT ================= */}
      {canInputLembur ? (
        <div className="lbr-card">
          <p className="lbr-card-title">Tambah Data Lembur</p>
          <div className="lbr-form-grid">
            <div className="lbr-field">
              <p className="lbr-label">Tanggal Lembur</p>
              <input
                type="date"
                className="lbr-input"
                value={dateFilter}
                onChange={(e) => setDateFilter(e.target.value)}
              />
            </div>

            <div className="lbr-field">
              <p className="lbr-label">
                Kepala<span className="lbr-req">*</span>
              </p>
              <select
                defaultValue="Pilih Kepala"
                className="lbr-select"
                value={filterKepala}
                onChange={(e) => setFilterKepala(e.target.value)}
              >
                <option selected disabled>
                  Pilih Kepala
                </option>
                {kepalaOptions.map((obj) => (
                  <option value={obj.value} key={obj.value}>
                    {obj.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="lbr-field">
              <p className="lbr-label">
                Operator<span className="lbr-req">*</span>
              </p>
              <Select
                placeholder="Pilih Operator"
                options={reFormat}
                value={operatorPick || ""}
                onChange={setOperatorPick}
              />
            </div>

            <div className="lbr-field">
              <p className="lbr-label">
                Rencana Masuk<span className="lbr-req">*</span>
              </p>
              <div className="lbr-time">
                <div>
                  <Select
                    placeholder="Jam"
                    options={clockJam}
                    value={rencanaMasuk || ""}
                    onChange={setRencanaMasuk}
                  />
                </div>
                <p className="lbr-time-suffix">: 00</p>
              </div>
            </div>

            <div className="lbr-field">
              <p className="lbr-label">
                Rencana Keluar<span className="lbr-req">*</span>
              </p>
              <div className="lbr-time">
                <div>
                  <Select
                    placeholder="Jam"
                    options={clockJam}
                    value={rencanaKeluar || ""}
                    onChange={setRencanaKeluar}
                  />
                </div>
                <p className="lbr-time-suffix">: 00</p>
              </div>
            </div>

            <div className="lbr-field">
              <p className="lbr-label">Pekerjaan</p>
              <input
                type="text"
                className="lbr-input"
                placeholder="Pekerjaan"
                value={pekerjaan}
                onChange={(e) => setPekerjaan(e.target.value)}
              />
            </div>

            <div className="lbr-field">
              <p className="lbr-label">Catatan</p>
              <input
                type="text"
                className="lbr-input"
                placeholder="Catatan"
                value={catatan}
                onChange={(e) => setCatatan(e.target.value)}
              />
            </div>
          </div>

          <div className="lbr-form-actions">
            <button className="lbr-btn" onClick={() => handleKirimLembur()}>
              Tambah
            </button>
          </div>
        </div>
      ) : (
        ""
      )}

      {/* ================= DAFTAR LEMBUR ================= */}
      <div className="lbr-card">
        <p className="lbr-form-code">Form-HRD-A16-R0</p>
        <h2 className="lbr-list-title">Daftar Lembur</h2>

        <div className="lbr-filters">
          <input
            type="date"
            className="lbr-input"
            value={dateFilter}
            onChange={(e) => setDateFilter(e.target.value)}
          />
          {dataUser && canFilterKepala ? (
            <select
              defaultValue="Pilih Kepala"
              className="lbr-select"
              value={filterKepalaList}
              onChange={(e) => setFilterKepalaList(e.target.value)}
            >
              <option selected disabled>
                Pilih Kepala
              </option>
              {kepalaOptions.map((obj) => (
                <option value={obj.value} key={obj.value}>
                  {obj.name}
                </option>
              ))}
            </select>
          ) : (
            ""
          )}
          <img
            src={RefreshIcon}
            alt="refresh"
            className="lbr-icon-btn"
            onClick={() => setIsReload(true)}
          />
          {!filterApproval && listLembur && listLembur.length > 0 ? (
            <img src={ApprovedIcon} alt="status" className="lbr-status-icon" />
          ) : (
            <img src={WaitingIcon} alt="status" className="lbr-status-icon" />
          )}
        </div>

        <div className="lbr-table-wrap">
          <table className="lbr-table">
            <thead>
              <tr>
                <th className="lbr-th" style={{ width: "5%" }}>
                  No
                </th>
                <th className="lbr-th" style={{ width: "25%" }}>
                  Nama
                </th>
                <th className="lbr-th">Rencana Masuk</th>
                <th className="lbr-th">Aktual Masuk</th>
                <th className="lbr-th">Rencana Keluar</th>
                <th className="lbr-th">Aktual Keluar</th>
                <th className="lbr-th" style={{ width: "25%" }}>
                  Pekerjaan
                </th>
                <th className="lbr-th" style={{ width: "4%" }}></th>
              </tr>
            </thead>
            <tbody>
              {listLembur && listLembur.length > 0 ? (
                listLembur.map((e, index) => (
                  <tr key={index}>
                    <td className="lbr-td">{index + 1}.</td>
                    <td className="lbr-td lbr-td--left">{e.name}</td>
                    <td className="lbr-td">
                      {moment(e && e.rencanaMasuk, "h:mm:ss A").format("HH:mm")}
                    </td>
                    <td className="lbr-td">
                      {e.aktualMasuk
                        ? moment(e && e.aktualMasuk).format("HH:mm")
                        : ""}
                    </td>
                    <td className="lbr-td">
                      {moment(e && e.rencanaKeluar, "h:mm:ss A").format(
                        "HH:mm"
                      )}
                    </td>
                    <td className="lbr-td">
                      {e.aktualKeluar
                        ? moment(e && e.aktualKeluar).format("HH:mm")
                        : ""}
                    </td>
                    <td className="lbr-td lbr-td--left">{e.pekerjaan}</td>
                    <td className="lbr-td">
                      <img
                        className="lbr-state-icon"
                        src={e.aktualKeluar ? ApproveIcon : CancelIcon}
                        alt={e.aktualKeluar ? "selesai" : "belum selesai"}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="lbr-empty" colSpan={8}>
                    Belum ada data lembur.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="lbr-note">
          <p className="lbr-note-label">Catatan</p>
          <p>{filterCatatan && filterCatatan[0]}</p>
        </div>
      </div>
    </div>
  );
};
export default LemburKaryawan;
